package com.ijoin.platform

data class Currency(
    val code: String,
    val symbol: String,
    val name: String
)

expect fun getLocalCurrency(): Currency
expect fun getAllCurrencies(): List<Currency>





